import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HttpProgressService {
  private activeRequests = signal(0);

  isLoading = computed(() => this.activeRequests() > 0);

  increment() {
    this.activeRequests.update(v => v + 1);
  }

  decrement() {
    this.activeRequests.update(v => Math.max(0, v - 1));
  }
}
